import { FieldArray } from "@progress/kendo-react-form";
import { ParameterGrid } from "./DatasetGrid/Parameter/ParameterListGrid";
import { datasetData } from "./NewDatasetSignals";

export const ParameterDataset = ({ formRenderProps }) => {
  return (
    <>
      <div className="white-section">
        <h2>Parameter Data</h2>
        <div className="table-input-grid">
          <FieldArray
            name="parameterGrid"
            component={ParameterGrid}
            value={datasetData.value.values.map((row) => row)}
            onChange={(newListData) => {
              datasetData.value = { ...datasetData.value, values: newListData };
              formRenderProps.onChange("parameterGrid", newListData);
            }}
          />
        </div>
      </div>
      {formRenderProps.errors.listGrid && (
        <div className="error">{formRenderProps.errors.listGrid}</div>
      )}
    </>
  );
};
